import * as React from "react"
import { connect } from "react-redux"
import Upload from "rc-upload"

import { Symbols } from "@tenforce/toolbox-fontmap"
import {
    Body,
    CompleteFooter,
    LoadingBody,
    Table,
} from "@tenforce/toolbox-table-react"

import env from "../../../../env"
import { GlobalState } from "../../../../store"

import { DispatchProps, mapDispatchToProps } from "../../actions"

import { PlaceholderRow, Row } from "./Row"
import TableHeader from "./TableHeader"
import { Labels } from "../../../../util/Translations"

declare let window: OldUIContext.TenForceWindow

const applicationPath = env.applicationPath
const feedback = env.feedback

type StateProps = Deployment.Deployment

type Props = StateProps & DispatchProps

interface State {
    uploading: boolean
}

export class Import extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            uploading: false,
        }
    }

    render(): JSX.Element {
        const { uploading } = this.state
        const {
            packageDiffs,
            makeSnapshot,
            configurations,
            configurationsLoading,
        } = this.props

        const loadingPackageDiffs =
            configurations.length - Object.keys(packageDiffs).length

        const { ChangeTracker, ImportPackageDescription } = Labels
        return (
            <div className="tw-mx-8 tw-py-5">
                <h4>{ImportPackageDescription}</h4>

                <Upload
                    action={`${applicationPath}/connectapi/deployment/importpackage?feedback=${feedback}`}
                    component="div"
                    className="tw-w-4/5 theme-note text-action tw-p-18 tw-my-5 tw-mx-auto tw-text-center"
                    disabled={uploading}
                    onStart={this.onStart}
                    onSuccess={this.onSuccess}
                    onError={this.onError}
                >
                    <h2>{Symbols.Create}</h2>
                </Upload>

                <div className="separator-line is-dotted is-dimmed"></div>

                <h4 className="tw-my-5">{ChangeTracker}</h4>

                <Table data-ft-imports-table>
                    <TableHeader />

                    {configurationsLoading ? (
                        <LoadingBody id="importsLoading" />
                    ) : (
                        <Body>
                            {Object.values(packageDiffs)
                                .sort(this.comparePackageName)
                                .map((packageDiff) => (
                                    <Row
                                        key={packageDiff.configuration.id}
                                        packageDiff={packageDiff}
                                        makeSnapshot={makeSnapshot}
                                    />
                                ))
                                .concat(
                                    [...Array(loadingPackageDiffs).keys()].map(
                                        (key) => <PlaceholderRow key={key} />,
                                    ),
                                )}
                        </Body>
                    )}

                    <CompleteFooter />
                </Table>
            </div>
        )
    }

    comparePackageName(
        a: Deployment.PackageDiff,
        b: Deployment.PackageDiff,
    ): number {
        return a.configuration.name
            .toLocaleUpperCase()
            .localeCompare(b.configuration.name.toLocaleUpperCase())
    }

    onStart = (): void => {
        window.feedback.clear()
        const { ImportPackage } = Labels
        window.feedback.displayInfo(`${ImportPackage}...`, false, false)
        // start polling for feedback immediately.
        window.feedback.scheduleGetFeedbackMessages()
        this.setState({ uploading: true })
    }

    onSuccess = (): void => {
        this.setState({ uploading: false })
    }

    onError = (): void => {
        this.setState({ uploading: false })
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.deployment

export default connect(mapStateToProps, mapDispatchToProps)(Import)
